import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { AddressSearch, SearchAddress } from "../models/address-search.model";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: 'root'
})
export class AddressSearchService {

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public getAddressSearch(address: string, defaultSearchCountry?: string): Observable<AddressSearch> {
    let queryString = `?address=${address}`;

    if (!_.isNil(defaultSearchCountry) && defaultSearchCountry !== '' && defaultSearchCountry.toLocaleLowerCase() !== 'other') {
      let searchCountry = defaultSearchCountry;

      // Make sure it's a 3 digit country id
      switch (searchCountry.toLocaleLowerCase()) {
        case 'nz':
          searchCountry = 'nzl';
          break;
        case 'au':
          searchCountry = 'aus';
          break;
      }

      queryString += `&defaultsearchcountry=${searchCountry}`;
    }

    return this.http.get<AddressSearch>(`${this.appConfigService.getConfig().apiUrl}addresssearch${queryString}`);
  }

  public postAddressPopulate(id: string): Observable<SearchAddress> {
    return this.http.post<SearchAddress>(`${this.appConfigService.getConfig().apiUrl}addresssearch/populate`, { id });
  }
}
